// Gemeinsame Optik der Eingabefelder (DESIGN §3.6.3): Fläche `input`, Radius 12, kein Rand im
// Dunkeln, im Hellen 1-px-Rand `line` (Hover `fg-tertiary`), Fokus-Ring 2 px direkt am Feld,
// invalid 1 px `danger`.
import { cn } from '../../basis/kern';

export type FieldSize = 'md' | 'lg';

export const fieldHeight: Record<FieldSize, string> = { md: 'h-10', lg: 'h-12' };

/** Rahmen um ein natives Feld (Wrapper mit `focus-within`). */
export const fieldFrame = (size: FieldSize | 'auto', extra?: string) =>
  cn(
    'group/field relative flex w-full min-w-0 items-center gap-2 rounded-lg border border-transparent bg-input px-3.5 text-body text-fg',
    'transition-colors duration-(--bar-dur-fast) ease-standard',
    '[[data-theme=light]_&]:border-line [[data-theme=light]_&]:hover:border-fg-tertiary',
    'focus-within:outline-2 focus-within:outline-offset-0 focus-within:outline-focus focus-within:outline-solid',
    'has-[[aria-invalid=true]]:border-danger! has-disabled:cursor-not-allowed has-disabled:text-fg-disabled',
    size === 'auto' ? '' : fieldHeight[size],
    extra,
  );

/** Das native Feld selbst: füllt den Rahmen, eigener Fokus-Ring aus (der Rahmen zeigt ihn). */
export const fieldInput = cn(
  'h-full min-w-0 flex-1 bg-transparent text-body text-fg outline-none placeholder:text-fg-placeholder',
  'focus-visible:outline-none disabled:cursor-not-allowed disabled:text-fg-disabled',
);

/** Auslöser im Feld-Look (Select, DatePicker, Combobox): ein Knopf mit Fokus-Ring am Knopf. */
export const fieldTrigger = (size: FieldSize) =>
  cn(
    'relative flex w-full min-w-0 items-center gap-2 rounded-lg border border-transparent bg-input px-3.5 text-left text-body text-fg',
    'transition-colors duration-(--bar-dur-fast) ease-standard',
    '[[data-theme=light]_&]:border-line [[data-theme=light]_&]:hover:border-fg-tertiary',
    'focus-visible:outline-offset-0 aria-invalid:border-danger!',
    'disabled:cursor-not-allowed disabled:text-fg-disabled data-[placeholder]:text-fg-placeholder',
    fieldHeight[size],
  );

/** Icon im Feld: 16, `fg-secondary`. */
export const fieldIcon = 'inline-flex shrink-0 text-fg-secondary [&>svg]:size-4';
